import calamityMapService from "../api/server/calamityMapService";
import errorHelper from "@/components/helpers/errorhelper";
export const CALAMITY_MAP_NAMESPACE = "calamityMapModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/calamityMapService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(calamityMapService)
};

const helpers = {
  makeMarkers(data, filter, clientId, locationId) {
    var calamityMarkers = [];
    var clientCount = {};
    var locationCount = {};
    var keys = [
      "AtOrigin",
      "InTransitArrived",
      "InTransitDeparted",
      "AtDestinationMetro",
      "Exception"
    ];

    _.each(data, function(e, i, l) {
      var totals = {};
      keys.forEach(key => {
        totals[key] = 0;
      });

      e.data.forEach(x => {
        /* istanbul ignore else */
        if (
          (x.ClientId === clientId ||
            clientId === null ||
            (x.ClientId === 3 && clientId === 4)) &&
          (x.LocationId === locationId || locationId === null)
        ) {
          keys.forEach(key => {
            if (filter[key] === true) totals[key] += x[key];
          });
        }
        var total = 0;
        keys.forEach(key => {
          if (filter[key] === true) total += x[key];
        });
        var clientProp = "clientId" + x.ClientId;
        if (x.ClientId === 3) clientProp = "clientId4";
        if (clientCount.hasOwnProperty(clientProp)) {
          clientCount[clientProp] += total;
        } else {
          clientCount[clientProp] = total;
        }
        if (locationCount.hasOwnProperty("locationId" + x.LocationId)) {
          locationCount["locationId" + x.LocationId] += total;
        } else {
          locationCount["locationId" + x.LocationId] = total;
        }
      });

      var t = 0;
      keys.forEach(key => {
        t += totals[key];
      });

      var m = {
        geometry: {
          type: "Point",
          coordinates: [e.Lon, e.Lat]
        },
        type: "Feature",
        properties: {
          Id: i,
          Name: e.City + ", " + e.State,
          Total: t,
          Type: "marker",
          Data: totals,
          Coords: [e.Lat, e.Lon],
          OriginalCoords: [e.Lat, e.Lon],
          HashKey: e.HashKey
        }
      };

      if (t > 0 && e.Lat && e.Lon) calamityMarkers.push(m);
    });

    return {
      calamityMarkers: calamityMarkers,
      clientCount: clientCount,
      locationCount: locationCount
    };
  }
};

const state = {
  calamityMarkers: [],
  data: [],
  clientData: [],
  clientCount: {},
  locationCount: {}
};
const actions = {
  async LOAD_PACKAGES(context, filter) {
    var api = await services.api;
    return api
      .loadPackages(context)
      .then(function(value) {
        context.state.data = value;
        context.commit("LOAD", filter);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async LOAD_CLIENTS(context) {
    var api = await services.api;
    return api
      .loadClients(context)
      .then(function(value) {
        context.commit("SET_CLIENTS", value);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  FILTER(context, filter) {
    context.commit("FILTER", filter);
  },
  async LOAD_WITH_FILTER(context, filter) {
    var api = await services.api;
    return api
      .loadPackages(context)
      .then(function(value) {
        context.state.data = value;
        context.commit("FILTER", filter);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  }
};
const mutations = {
  LOAD(storeState, filter) {
    storeState.calamityMarkers = [];
    var markerData = helpers.makeMarkers(storeState.data, filter, null, null);
    storeState.calamityMarkers = markerData.calamityMarkers;
    storeState.clientCount = markerData.clientCount;
    storeState.locationCount = markerData.locationCount;
  },
  SET_CLIENTS(storeState, clientData) {
    // AllianceRx contains Ids 3 & 4, locations need to be merged and only one client show
    let client3 = clientData.find(x => x.Id === 3);
    let client4 = clientData.find(x => x.Id === 4);
    /* istanbul ignore else */
    if (client3 && client4) {
      client3.Locations.forEach(loc => {
        client4.Locations.push(loc);
      });
    }
    var filteredClients = clientData.filter(x => {
      return x.Id !== 3;
    });

    storeState.clientData = filteredClients;
  },
  FILTER(storeState, filter) {
    var markerData = helpers.makeMarkers(
      storeState.data,
      filter.transitFilter,
      filter.selectedClientId,
      filter.selectedLocationId
    );
    storeState.calamityMarkers = markerData.calamityMarkers;
    storeState.clientCount = markerData.clientCount;
    storeState.locationCount = markerData.locationCount;
  }
};
const getters = {
  calamityMarkers: storeState => storeState.calamityMarkers,
  data: storeState => storeState.data,
  clientData: storeState => storeState.clientData,
  clientCount: storeState => storeState.clientCount,
  locationCount: storeState => storeState.locationCount
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services,
  helpers
};
